<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                  <el-col :span="12" class="item">
                    <div class="label">机构</div>
                    <el-select v-model="institutionCode" placeholder="请选择机构" style="width: 100%;">
                      <el-option
                          v-for="item in arr_ins"
                          :key="item.institutionCode"
                          :label="item.userName"
                          :value="item.institutionCode">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12" class="item">
                    <div class="label">姓名</div>
                    <el-input v-model="edit_realName" placeholder="请输入姓名"></el-input>
                  </el-col>

                  <el-col :span="12" class="item">
                    <div class="label">手机</div>
                    <el-input v-model="edit_phone" placeholder="请输入手机"></el-input>
                  </el-col>


                    <el-col :span="12" class="item">
                        <div class="label">状态</div>
                        <el-select v-model="edit_status" placeholder="选择状态" @change="changeStatus" style="width: 100%">
                            <el-option
                                    v-for="item in status2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">组织</div>
                        <elSelectTree :options='zoneList' accordion :value='edit_zoneCode' v-if="zoneList.length>0"
                                      :props="{ emitPath:false,value: 'value',label: 'label',children: 'children' }"
                                      v-on:getZoneValue="getZoneValue" style="width: 100%"></elSelectTree>
                    </el-col>
                </el-row>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import elSelectTree from "@/components/ElSelectTree"


    export default {
        name: 'Edit',
        props: ['arr_ins'],
        data() {
            return {

                loading: false,

                edit_realName:'',
                edit_phone:'',
                edit_zoneCode:'',
              institutionCode:'',


                zoneList:[],

                status2: [ {
                    value: 1,
                    label: '正常'
                }, {
                  value: 2,
                  label: '被禁用'
                }
                ],

              edit_status: '',
              assessCode:'',


            }
        },
        components:{
            elSelectTree
        },
        methods: {
            init(row){

                this.edit_realName = row.userName;

                this.edit_phone = row.phone;
                this.edit_status = row.status;

                this.institutionCode = row.institutionCode;

                this.zoneList = [];

                this.assessCode = row.assessCode;

                this.getListZone(row.zoneCode);

            },
            getZoneValue(val){
                this.edit_zoneCode=val
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(){


                if(this.edit_realName == ''){
                    this.$message('请添加用户名');
                    return;
                }
                if(this.edit_phone == ''){
                    this.$message('请添加手机号');
                    return;
                }
                if(!this.edit_zoneCode){
                    this.$message('请添加组织');
                    return;
                }
              if(this.institutionCode==''){
                this.$message('请选择机构');
                this.loading = false;
                return;
              }

              if(this.loading){
                return;
              }else{
                this.loading = true;
              }

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Assess/GovEditIns',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                      institutionCode:this.institutionCode,

                        name:this.edit_realName,

                        phone:this.edit_phone,

                        status:this.edit_status,
                        zoneCode:this.edit_zoneCode,
                        assessCode:this.assessCode,

                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.$emit("closeEdit");
                        this.$emit("getList");
                    }else{
                        this.$message(response.data.Message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },


            changeStatus:function (selVal) {
                this.edit_status = selVal;
            },

            getListZone(data){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Zone/List',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response)=> {
                    if(response.data.error == 0){
                        let aa  = JSON.stringify(response.data.data);
                        aa =  aa.replace(/listZoneDTO/g,"children");
                        aa =  aa.replace(/zoneCode/g,"value");
                        aa =  aa.replace(/name/g,"label");
                        this.zoneList = JSON.parse(aa);

                        this.edit_zoneCode = data;


                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }


    }
</script>


<style>

</style>
